
import { RootState } from "@/@types/store";
import { computed, defineComponent, ref, watch } from "vue";
import { FormDialog } from "@/components/Common";

import { useDialogCommon, useDialogFormData } from "@/hooks";
import _ from "lodash";

import { ElMessage } from "element-plus";
import { useStore } from "vuex";
import { GetBalanceWarningReminderList, SetBalanceWarningReminder } from "@/api-server/modules/defaultServer";

export default defineComponent({
  props: {
    visible: { type: Boolean, default: false },
    formData: {
      type: Object,
      default: () => ({ items: [] }),
    },
  },

  components: {
    FormDialog,
  },

  emits: ["update:visible", "updateSuccess"],

  setup(props, context) {
    const { visibleRef } = useDialogCommon(props, context);
    const { editFormData } = useDialogFormData(
      props,
      { items: [] as BUSINESS_SERVE_PLATFORM_PC.GetBalanceWarningReminderListResponseDataItem[] },
      {
        type: "resetWithPropsFormData",
        visiableRef: visibleRef,
      }
    );
    const store = useStore<RootState>();

    const rules = {
      earlyWarningReminderValue: [
        { required: true, message: "请输入预警余额", trigger: "blur" },
        {
          validator: (rule: any, value: number, callback: any) => {
            if (value <= 0 ) {
              callback('请输入大于0的数字')
            } else {
              callback()
            }
          }
        }
      ]
    };

    async function saveFormHandle() {
      if (editFormData.value.items.length <=0 ) 
        return ElMessage.warning({ showClose: true, message: "暂无可设置的余额数据" });
      await SetBalanceWarningReminder.fetch({ 
        balanceWarningReminders: editFormData.value.items
      })
      ElMessage.success({ showClose: true, message: "设置成功" });
      visibleRef.value = false;
      context.emit("updateSuccess");
    }


    return {
      rules,
      visibleRef,
      editFormData,
      saveFormHandle,
      store,
    };
  },
});
